import { FeatureFlagKeys } from '@modules/FeatureFlagModule/featureFlagKeys';
import useFeatureFlag from '@modules/FeatureFlagModule/hooks/useFeatureFlag/useFeatureFlag';

/**
 * React counterpart of `InboxModule.isBookingRetentionEnabled()`.
 */
export default function useBookingRetentionEnabled(): boolean {
  return !!useFeatureFlag(FeatureFlagKeys.featureRetainEndedCallCards, {
    defaultValue: false,
  });
}
